var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-add.60f33eb5.png","uri@2x": __webpack_public_path__ + "icon-add.3337e235.png","uri@3x": __webpack_public_path__ + "icon-add.573ce936.png",
    width: 47,
    height: 46
});